export default "__VITE_ASSET__D3qY_WsD__"